import React from "react";
import PageSection from "./PageSection";

import {
  FaReact,
  FaLink,
  FaCube,
  FaSeedling,
  FaCommentDots
} from "react-icons/fa";

const Customers = () => {
  const facts = [
    {
      id: 1,
      title: "Side Projects",
      subtitle: "「Members」 will be arranged to the side project team!",
    },
    {
      id: 2,
      title: "Publication",
      subtitle: "「Members」 in the swfLab should publish articles in our Medium Publication to maintain their qualification.",
    },
    {
      id: 3,
      title: "Resource",
      subtitle: "「Everyone」 here can obtain all free resource of Web3 Dev., Full-Stack Dev. and Financial & Economics Reserch.",
    },
    {
      id: 4,
      title: "Consultancy",
      subtitle: "The 「member」 who has done one side project will have a chance to interview with some Masters in industry.",
    },
  ];

  const companies = [
    {
      id: 1,
      icon: <FaReact size={25} />,
      title: "Dapp Development",
    },
    {
      id: 2,
      icon: <FaCube size={25} />,
      title: "Blockchain Research",
    },
    {
      id: 3,
      icon: <FaLink size={25} />,
      title: "Free Learning Resource",
    },
    {
      id: 4,
      icon: <FaSeedling size={25} />,
      title: "Friendly Onboarding",
    },
    {
      id: 5,
      icon: <FaCommentDots size={25} />,
      title: "Referral Program",
    },
  ];

  return (
    <PageSection
      name="targets"
      title="Targets"
      subtitle={`What does the member do in swfLab?`}
    >
      <>
        <div className="grid lg:grid-cols-4 text-left gap-8 mb-16">
          {facts.map(({ id, title, subtitle }) => (
            <div
              key={id}
              className="odd:bg-thBlue even:bg-thOrange text-black p-4 rounded-lg"
            >
              <h1 className="text-3xl font-bold mb-2">{title}</h1>
              <p>{subtitle}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-col lg:flex-row items-center justify-around gap-6">
          {companies.map(({ id, icon, title }) => (
            <div
              className="flex items-center capitalize p-4 rounded-lg"
              key={id}
            >
              {icon}
              <p className="ml-2">{title}</p>
            </div>
          ))}
        </div>
      </>
    </PageSection>
  );
};

export default Customers;
